module.exports = __webpack_public_path__ + "static/media/MaintenanceLogo-Bfree-centered.6474b195.png";